import { environment } from 'environments/environment';
import {
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { AppComponentBase } from "@shared/app-component-base";
import { FileUploadService } from "@shared/components/image-upload/file-upload.service";
import { catchError, finalize, tap } from "rxjs/operators";
import { ImageSnippet } from "./image-snippet";
import { FileParameter } from "./file-parameter";
import { HttpHeaders, HttpResponse } from "@angular/common/http";
import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from "rxjs/operators";
import {
  throwError as _observableThrow,
  of as _observableOf
} from "rxjs";
import { AppConsts } from "@shared/AppConsts";
@Component({
  selector: "image-upload",
  templateUrl: "image-upload.component.html",
  styleUrls: ["image-upload.component.scss"],
})
export class ImageUpload extends AppComponentBase implements OnChanges {
  @Input() isMulti: boolean = false;
  @Input() existImages: ImageSnippet[] = [];
  @Input() eliasImageName: string = "";
  @Input() filePath: string;
  loading = false;
  imageFile: FileParameter;
  images: ImageSnippet[] = [];
  @ViewChild("fileUpload") fileUpload: ElementRef;

  @Output() OnUpload: EventEmitter<any> = new EventEmitter<ImageSnippet>();
  @Output() OnUploadWithoutPath: EventEmitter<any> = new EventEmitter<ImageSnippet>();
  @Output() OnRemove: EventEmitter<any> = new EventEmitter<any>();

  imageExtensions = ["png", "jpg", "jpeg", "gif", "tiff", "svg"];

  maxResultCount = 10;
  // filePath = "reciept";

  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    injector: Injector,
    private _fileUploadService: FileUploadService,
  ) {
    super(injector);
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.images = this.existImages.map((image) => {
      let src = image.src ?? `${AppConsts.s3Url}/${image.name}`;
      return new ImageSnippet(image.name, src);
    });
  }

  onUpload(event): void {
    let fileName: string = event.target.files[0].name;
    const fileExtension = fileName.substring(
      fileName.lastIndexOf(".") + 1,
      fileName.length
    );
    if (!this.imageExtensions.includes(fileExtension)) {
      abp.notify.error(this.l("InvalidFile"));
      return;
    }

    this.loading = true;
    this._fileUploadService.setIsPending(this.loading);

    fileName = `${this.eliasImageName}_${fileName.replace(" ", "_")}`;
    var reader = new FileReader();
    let image = new ImageSnippet(fileName);
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (res) => {
      image.src = res.target.result;
      this.images.push(image);
    };
    reader.onerror = function (error) {};
    let fileParameter: FileParameter = {
      data: event.target.files[0],
      fileName: fileName,
    };

    this.uploadFile(this.filePath, fileParameter);

  }

  removeImage(imageName: string, index: number) {
    this.images = this.images.filter((x, i) => i != index);
    this.OnRemove.emit({imageName: imageName,index: index});
  }

  openPreview(url: string) {
    window.open(url, "_blank");
  }

  uploadFile(filePath: string | undefined, file: FileParameter | undefined) {
    filePath = `${environment.UploadFolder}/${filePath}`
    this._fileUploadService
      .uploadFile(filePath, file)
      .pipe(
        finalize(() => {
          this.loading = false;
          this._fileUploadService.setIsPending(this.loading);
        })
      )
      .subscribe((response: any) => {
        let imageName = response?.fileName;
        const imageUrl = `${AppConsts.s3Url}/${filePath}/${imageName}`;
        let imagePath = `${filePath}/${imageName}`;
        let image = new ImageSnippet(imagePath, imageUrl);
        this.fileUpload.nativeElement.value = "";
        this.OnUpload.emit(image);
        this.OnUploadWithoutPath.emit(imageName);
      });
  }
}
